import { useSelector } from 'statux'

import Image from '../../../../components/Image/Image'
import RichText from '../../../../components/RichText/RichText'

import authProvider from '../../../../utils/auth-provider'

export default function DashboardHomeEbpcAside (props = {
    className: null
}) {
    const {
        ebpcAssignmentsOpen,
        ebpcAssignmentsEndDateStr,
        ebpcFinalsOpen,
        ebpcFinalsEndDateStr
    } = useSelector()

    const isEbpcJudge = authProvider.getDefaultRole() === 'ebpc_judge'

    const isEbpcReviewer = authProvider.getDefaultRole() === 'ebpc_reviewer'

    if (!(isEbpcJudge
            || isEbpcReviewer))
        return null

    return (
        <aside
            className={`dashboard-home-ebpc-aside ${props.className || ''}`
                .trim()}
        >
            <div className="dashboard-home-ebpc-aside-banner pad-0 card card-offscreen-x-lg-down margin-1-b margin-3-b-lg-up">
                <div className="ratio-wide">
                    <Image
                        src="/images/ebpc-competition-ceremony.png"
                        alt="Photo of GSE members at the EBPC ceremony"
                        data-object-fit="cover"
                    />
                </div>
            </div>
            <div className="dashboard-home-ebpc-aside-instructions card card-offscreen-x-lg-down pad-0-t margin-1-b margin-3-b-lg-up">
                <div className="dashboard-home-ebpc-aside-instructions-banner">
                    <Image
                        src="/images/ebpc-logo.svg"
                        alt="Milken Penn GSE Education Business Plan Competition logo"
                        aria-hidden="true"
                        width="153"
                        height="29"
                    />
                </div>
                {(ebpcAssignmentsOpen
                        || ebpcFinalsOpen)
                    && isEbpcJudge
                    && <h2 className="heading-5">Instructions</h2>}
                <RichText
                    className="body-4"
                >
                    {(ebpcAssignmentsOpen
                            || ebpcFinalsOpen)
                        && isEbpcJudge
                        && (
                            <>
                                <p>
                                    Thank you for judging in the Milken-Penn GSE Education Business Plan Competition!
                                    {!ebpcFinalsOpen
                                        && ebpcAssignmentsEndDateStr
                                        && ` Please complete all reviews by ${ebpcAssignmentsEndDateStr}.`}
                                    {ebpcFinalsOpen
                                        && ebpcFinalsEndDateStr
                                        && ` Please complete all reviews by ${ebpcFinalsEndDateStr}.`}
                                </p>
                                {!ebpcFinalsOpen
                                    && (
                                        <>
                                            <p style={{ marginBottom: 5 }}>Quick start guide:</p>
                                            <ul>
                                                <li>Review the <a href="/dashboard/ebpc/judge-orientation">Judge orientation page</a></li>
                                                <li>For additional common questions, please see Judges often ask</li>
                                                <li>Select a venture from Applications for your review</li>
                                                <li>Review and rate each application</li>
                                                <li>Rank applications relative to each other</li>
                                                <li>Submit your final rankings</li>
                                            </ul>
                                        </>)}
                                <p>
                                    We want to ensure your judging experience is exceptional – please don't hesitate to contact us at&nbsp;
                                    <a
                                        href="mailto:educomp@gse.upenn.edu"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title="Opens in default mail client"
                                    >
                                        educomp@gse.upenn.edu
                                    </a>.
                                </p>
                            </>)}
                    {(!isEbpcJudge
                            || !(ebpcAssignmentsOpen
                                || ebpcFinalsOpen))
                        && (
                            <p>
                                <span>Questions?</span>
                                <br />
                                <span>
                                    Contact us at&nbsp;
                                </span>
                                <a
                                    href="mailto:educomp@gse.upenn.edu"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Opens in default mail client"
                                >
                                    educomp@gse.upenn.edu
                                </a>
                            </p>)}
                </RichText>
            </div>
        </aside>
    )
}
